<div *transloco="let t; read: 'widgets.options'" class="xi-modal__container">
  <h2 class="xi-modal__title kxi-text-center">
    {{ t('breakdown-or-driver-settings', { type }) }}
  </h2>

  <form class="xi-modal__content" [formGroup]="formGroup">
    <h3 class="predictive-chart-options__sub-title">{{ t('calculation.title') }}</h3>

    <div class="predictive-chart-options__input-group">
      <div class="predictive-chart-options__radio-group">
        @for (group of displayGroups; track group) {
          <!-- Horrible hack due to xi-radio not supporting disabled -->
          <div
            [matTooltip]="
              group.id === 'Box' && isBinaryField
                ? t('box-score-not-available-for-binary')
                : group.id === 'Box' && isBucketScoring
                  ? t('box-score-not-available-for-bucket-metric')
                  : group.id === 'NPS' && isBucketScoring
                    ? t('nps-not-available-for-bucket-metric')
                    : ''
            "
            [style.opacity]="
              (group.id === 'Box' && (isBinaryField || isBucketScoring)) ||
              (group.id === 'NPS' && isBucketScoring)
                ? '0.5'
                : '1'
            "
          >
            <xi-radio
              name="scoringStrategyRadios"
              formControlName="scoringStrategyRadios"
              [value]="group.id"
              [label]="group.label"
              [disabled]="
                (group.id === 'Box' && (isBinaryField || isBucketScoring)) ||
                (group.id === 'NPS' && isBucketScoring)
              "
              [style.pointer-events]="
                (group.id === 'Box' && (isBinaryField || isBucketScoring)) ||
                (group.id === 'NPS' && isBucketScoring)
                  ? 'none'
                  : 'auto'
              "
            ></xi-radio>
          </div>
        }
      </div>

      <xi-dropdown
        [placeholder]="t('sort-fields')"
        select="single"
        formControlName="boxDirectionSelect"
        [data]="boxDirectionDos"
      ></xi-dropdown>

      <xi-dropdown
        [placeholder]="t('sort-fields')"
        select="single"
        formControlName="boxSizeSelect"
        [data]="boxSizeDos"
      ></xi-dropdown>
    </div>

    <h3 class="predictive-chart-options__sub-title">{{ t('target-metric-scale') }}</h3>

    @if (isBinaryField) {
      <p class="predictive-chart-options__binary-message">
        {{ t('binary-field-scale-message') }}
      </p>
    }

    @if (isBucketScoring) {
      <p class="predictive-chart-options__binary-message">
        {{ t('bucket-scoring-scale-message') }}
      </p>
    }

    <div
      class="predictive-chart-options__input-group"
      [class.disabled]="isBinaryField || isBucketScoring"
    >
      <div class="predictive-chart-options__toggle-group">
        <label>{{ t('minimum-rating') }}</label>

        <xi-toggle-switch
          [leftText]="0"
          [rightText]="1"
          type="button"
          [isToggled]="isScaleToggled"
          [disabled]="isBinaryField || isBucketScoring"
          (onToggle)="formGroup.controls.scaleToggle.setValue($event.detail.isToggled ? 1 : 0)"
        ></xi-toggle-switch>
      </div>

      <xi-input-field
        required
        [label]="t('maximum-rating')"
        formControlName="scaleMax"
        type="number"
        [min]="2"
        [max]="1000"
        [status]="maxScaleStatus"
        [disabled]="isBinaryField || isBucketedField"
      ></xi-input-field>
    </div>
  </form>

  <div class="xi-modal__actions predictive-chart-options__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button
      [text]="t('apply')"
      [disabled]="!isFormValid"
      (onClick)="onSave()"
    ></xi-default-button>
  </div>
</div>
